import React from 'react';
import { Provider } from 'react-redux';
import Routes from '../Routes';
import { ConfigProvider } from 'antd';
import LanguageSpanish2 from 'antd/es/locale/es_ES';
import { Organizacion } from '../context/Organizacion'

const Root = ({ store, history }) => (
  <Organizacion>
    <Provider store={store}>
      <ConfigProvider locale={LanguageSpanish2}>
          <Routes history={history} />
      </ConfigProvider>
    </Provider>
  </Organizacion>
);

export default Root;
